<panel width="450">
	<h1>{{ 'questionnaire.list-questionnaire' | translate }}</h1>
	<blocklist blockListType="questionnaire"
			   [items]="questionnaires"
			   (onSelect)="selectQuestionnaire($event)"
			   [selectedItem]="selectedQuestionnaire">
	</blocklist>
</panel>
